import { IOptions } from "../components/FormFields/CustomSelect";
import { IRoles } from "../utils/account.types";
import axios from "../utils/axios";

/**
 * Method to fetch roles.
 */
const fetchRoles = async () => {
    try {
        const response = await axios.get<IRoles>('/roles');

        const { roles = [] } = response.data;
        const user = JSON.parse(localStorage.getItem('user') || '');

        // show only roles which are higher than the role of logged in user.
        const options = roles.reduce((acc: IOptions[], { _id, role, roleId }) => {
            if (roleId > user.roles[0].roleId) {
                acc.push({ label: role.toUpperCase(), value: _id });
            }

            return acc;
        }, []);

        return options;

    } catch (error: any) {
        // Empty catch block.
    }
}

const RoleService = {
    fetchRoles,
};

export default RoleService;